import React from 'react'
import EstradaNeon from '../EstradaNeon'
import SilhuetaBlumenau from '../SilhuetaBlumenau'
import { comDestaque } from '../../lib/destaque'
import { EVENTO } from '../../dados/evento'

/* Ícones — Tabler Icons (MIT), grid 24×24, a mesma família do resto da página. */
const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.7,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
}

function IconePino(props) {
  return (
    <svg {...base} {...props}>
      <path d="M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
      <path d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z" />
    </svg>
  )
}

function IconePredio(props) {
  return (
    <svg {...base} {...props}>
      <path d="M3 21l18 0" />
      <path d="M9 8l1 0" />
      <path d="M9 12l1 0" />
      <path d="M9 16l1 0" />
      <path d="M14 8l1 0" />
      <path d="M14 12l1 0" />
      <path d="M14 16l1 0" />
      <path d="M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16" />
    </svg>
  )
}

function IconeAgenda(props) {
  return (
    <svg {...base} {...props}>
      <path d="M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" />
      <path d="M16 3v4" />
      <path d="M8 3v4" />
      <path d="M4 11h16" />
      <path d="M11 15h1" />
      <path d="M12 15v3" />
    </svg>
  )
}

function IconeCarro(props) {
  return (
    <svg {...base} {...props}>
      <path d="M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
      <path d="M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
      <path d="M5 17h-2v-6l2 -5h9l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-6m-6 -6h15m-6 0v-5" />
    </svg>
  )
}

function IconeTalher(props) {
  return (
    <svg {...base} {...props}>
      <path d="M19 3v12h-5c-.023 -3.681 .184 -7.406 5 -12zm0 12v6h-1v-3m-10 -14v17m-3 -17v3a3 3 0 1 0 6 0v-3" />
    </svg>
  )
}

const ICONES_FATO = {
  agenda: IconeAgenda,
  carro: IconeCarro,
  talher: IconeTalher,
  pino: IconePino,
}

/* Os fatos do espaço. SÓ o que já constava da copy aprovada — data, horário,
   estacionamento próprio e o almoço por adesão. A arte mostra também
   "auditório climatizado" e "localização estratégica"; nada disso foi
   confirmado sobre o Grupo RVG Rivage no material entregue, e inventar
   característica de um local de evento é o tipo de erro que aparece no dia. */
const FATOS_LOCAL = [
  {
    titulo: `${EVENTO.dataLegivel}, das 8h às 19h`,
    texto: 'Um dia inteiro, do credenciamento ao encerramento.',
    icone: 'agenda',
  },
  {
    titulo: 'Estacionamento próprio',
    texto: 'Mais comodidade e segurança para quem vem de carro.',
    icone: 'carro',
  },
  {
    titulo: 'Almoço no local, por adesão',
    /* Era "contratado na inscrição", e isso CONTRADIZIA o formulário: lá
       (TEXTO_ALMOCO) a pessoa apenas sinaliza interesse e paga no local. Dizer
       "contratado" promete uma reserva que a inscrição não faz. */
    texto: 'Opcional, sinalizado na inscrição e pago no dia.',
    icone: 'talher',
  },
]

/**
 * 6ª dobra — localização.
 *
 * O mapa é um iframe do Google Maps no modo de busca por endereço, sem chave de
 * API: a Embed API cobra e exige credencial, e o que a página precisa é mostrar
 * onde fica — não geocodificar nem desenhar rota.
 *
 * `loading="lazy"` não é otimização opcional aqui. O iframe do Maps puxa mais de
 * 1 MB de script de terceiro; carregá-lo junto do resto da página derruba o LCP
 * de uma seção que fica abaixo de quatro dobras e que quase ninguém alcança
 * antes de se inscrever.
 */
export default function SecaoLocal({
  chamada = 'Nos vemos em Blumenau!',
  texto = `Para quem garantir o ingresso, o encontro acontece no dia ${EVENTO.dataLegivel}, das 8h às 19h, no ${EVENTO.local}, com estacionamento próprio.`,
  textoDestaque = `${EVENTO.dataLegivel}, das 8h às 19h`,
  endereco = EVENTO.endereco,
  fatos = FATOS_LOCAL,
  /* SEM MASCOTE nesta dobra desde 12/08, a pedido do cliente.

     Duas coisas erradas de uma vez: `nauta-rota-1` é o recorte PEQUENO e em
     paisagem, e é o único da família com bandeira BRANCA (os outros quatro
     carregam a bandeira azul do logo) — então ele chegava miúdo e fora do
     padrão, encostado na quina de um bloco largo. O Nauta já aparece em sete
     outros pontos da página; aqui ele não estava contando nada. */
  mascote = null,
}) {
  const consulta = encodeURIComponent(`${EVENTO.local}, ${endereco}`)

  /* Mesma partição do H1 do hero: o título é peça gráfica, em caixa alta e
     duas linhas, a segunda em azul. */
  const palavras = chamada.trim().split(' ')
  const ultima = palavras.length > 1 ? palavras.pop() : ''
  const resto = palavras.join(' ')

  return (
    <section className="secao secao-local noite" id="local">
      <SilhuetaBlumenau className="silhueta local-silhueta" />
      {mascote && (
        <img className="local-nauta" src={mascote} alt="" width="420" height="420" loading="lazy" />
      )}

      <div className="container-site">
        {/* Cabeçalho centralizado, com o nome da cidade em escala de cartaz —
            é a lâmina de encerramento da arte aprovada. */}
        <div className="cabecalho-secao cabecalho-centro local-cabecalho">
          <span className="eyebrow">Onde acontece</span>
          <h2 className="local-titulo display-cartaz">
            <span className="apenas-leitor">{chamada}</span>
            <span aria-hidden="true">
              {resto}
              {ultima && (
                <>
                  <br />
                  <span className="realce">{ultima}</span>
                </>
              )}
            </span>
          </h2>
          <p className="local-resumo cartao">{comDestaque(texto, textoDestaque)}</p>
        </div>

        <div className="local-interno">
          {/* CARTÃO DO MAPA — o iframe com o endereço embaixo, dentro da mesma
              moldura. Antes o endereço vivia na coluna de texto, longe do
              mapa; na arte os dois são um bloco só, sob o rótulo "Onde será?". */}
          <div className="cartao cartao-arte local-bloco">
            <p className="local-bloco-rotulo">
              <span className="local-bloco-icone" aria-hidden="true">
                <IconePino />
              </span>
              Onde será?
            </p>

            <div className="local-mapa">
              <iframe
                title={`Mapa de ${EVENTO.local}`}
                src={`https://maps.google.com/maps?q=${consulta}&output=embed`}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
              {/* Traçado de rota, por cima do canto do mapa — encaixe literal
                  aqui: é o mapa até o destino. Fica sobre o mapa (que já tem
                  textura própria), nunca sobre parágrafo legível. */}
              <EstradaNeon className="local-rodovia" />
            </div>

            <address className="local-endereco">
              <span className="local-endereco-pin" aria-hidden="true">
                <IconePino />
              </span>
              {endereco}
            </address>

            {/* PINO NO BOTÃO (13/08, pedido do cliente). O rótulo diz "mapa"
                e o botão não trazia nenhum sinal de mapa — era o único CTA da
                página sem ícone, ao lado de um cartão em que cada linha tem o
                seu. */}
            <a
              className="btn btn-vazado local-cta"
              href={`https://www.google.com/maps/search/?api=1&query=${consulta}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <IconePino className="local-cta-icone" aria-hidden="true" />
              Abrir no Google Maps
            </a>
          </div>

          {/* CARTÃO DO ESPAÇO — os fatos do local, cada um com o selo do
              ícone, título e uma linha de explicação. Só o que já estava na
              copy aprovada; nada foi inventado sobre o espaço. */}
          {/* A PLACA "O LOCAL" SAIU (13/08, pedido do cliente: "pode tirar o
              título, pois já está subconsciente que a gente já está no
              local"). Ele está certo: a dobra inteira se chama "Nos vemos em
              Blumenau", o cartão ao lado diz "Onde será?" e este traz uma foto
              da fachada com o nome do espaço logo abaixo. A placa era o quarto
              rótulo dizendo a mesma coisa — e era ela que empurrava a foto
              para baixo, impedindo que a imagem encostasse no topo do cartão. */}
          <div className="cartao cartao-arte local-bloco local-bloco-espaco">
            {/* FOTO REAL DO ESPAÇO (12/08, PDF do cliente): "trazer a foto do
                local do evento real também". A referência que ele anexou é
                exatamente esta composição — mapa à esquerda, foto do prédio
                com os fatos embaixo à direita.

                O arquivo não veio junto do material (só dentro do PDF), então
                o campo nasce vazio e o bloco fecha sem a imagem. Preencher
                `EVENTO.localFoto` é o único passo que falta. */}
            {EVENTO.localFoto && (
              <img
                className="local-foto"
                src={EVENTO.localFoto}
                alt={`Fachada do ${EVENTO.local}, onde acontece o evento`}
                width="900"
                height="600"
                loading="lazy"
              />
            )}

            <p className="local-venue">{EVENTO.local}</p>

            <ul className="local-fatos lista-limpa">
              {fatos.map(({ titulo, texto: nota, icone }) => {
                const Icone = ICONES_FATO[icone] || IconePino
                return (
                  <li key={titulo}>
                    <span className="selo-icone local-fato-selo" aria-hidden="true">
                      <Icone />
                    </span>
                    <div>
                      <strong>{titulo}</strong>
                      {nota && <span>{nota}</span>}
                    </div>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>

        {/* FAIXA DE FECHO — data, horário e endereço numa linha só, como o
            rodapé da lâmina. É a última coisa que a pessoa lê antes do bloco
            institucional, e a informação que ela vai procurar de novo depois
            de se inscrever. */}
        <p className="local-faixa">
          <span className="local-faixa-icone" aria-hidden="true">
            <IconeAgenda />
          </span>
          <strong>{EVENTO.dataLegivel}</strong>
          <span className="local-faixa-ponto" aria-hidden="true" />
          {EVENTO.horario}
          <span className="local-faixa-fio" aria-hidden="true" />
          <strong>{EVENTO.local}</strong>
          <span className="local-faixa-ponto" aria-hidden="true" />
          {EVENTO.cidade}
        </p>
      </div>
    </section>
  )
}
